import { Component, ComponentFactoryResolver, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, AuthService, ButtonLoader, ConfigService, FormsUtilsService, MessageService } from '../../../core';
import { DatepickerComponent } from '../../../shared';
import { ConfigEmpresa, createNomeCliente } from '../../configuracoes/app/empresa';
import { LeadSearch} from '../../crm/lead/lead-search';
import { LeadSearchHttpService } from '../../crm/lead/services';
import { LeadTypeaheadComponent } from '../../crm/lead/typeahead';
import { Cliente } from '../../pessoa/cliente/cliente';
import { ClienteCrudHttpService } from '../../pessoa/cliente/services/cliente-crud-http.service';
import { TypeaheadClienteComponent } from '../../pessoa/cliente/typeahead/typeahead-cliente.component';
import { PessoaContato, PessoaContatoComponent, PessoaContatoHttpService, contatoTipoPrincipal } from '../../pessoa/contato';
import { enderecoTipoPrincipal } from '../../pessoa/endereco';
import { PessoaEnderecoContato } from '../../pessoa/pessoa-endereco-contato';
import { PessoaEnderecoContatoHttpService } from '../../pessoa/services';
import { Usuario } from '../../usuario';
import { Atividade, mapToRef } from '../atividade';
import { AtividadeAfterSave } from '../atividade-after-save';
import { isLancamentoAutomatico } from '../atividade-lancamento';
import { isOrigemRetorno, origemAtividade } from '../atividade-origem';
import { referenciaCliente, atividadeReferencias, isReferenciaCliente, isReferenciaLead } from '../referencia';
import { AtividadeChecklistItemComponent } from '../checklist-item';
import { AtividadeCrudHttpService } from '../services';
import { AtividadeTipo, atividadesTiposLancamentoManual, isTipoClienteRevisao, isTipoClienteTituloVencido, isTipoEntrarEmContato, isTipoTarefa, isTipoVisitar, tipoEntrarEmContato } from '../tipo';
import { ContatoIniciativaCardControlRadioComponent } from '../../common/contato/inciativa/components/card-control-radio';
import { AtividadeRetornoFormComponent } from '../retorno/form';
import { AtividadeRef } from '../ref';

interface Config {
    isOrigemRetorno: boolean;
    isConcluida: boolean;
    isAtrasada: boolean;
    isPendente: boolean;
    canEditPrazo: boolean;
}

@Component({
    selector: 'sgt-atividade-form-modal',
    templateUrl: './atividade-form-modal.component.html',
    styleUrls: ['./atividade-form-modal.component.less']
})
export class AtividadeFormModalComponent implements OnInit {
    config: Config;
    configEmpresa: ConfigEmpresa;
    isAdministrador: boolean;
    isGerente: boolean;
    isAtendente: boolean;

    elModal: any;
    entity: Atividade;
    referencias = atividadeReferencias;

    // Contato
    @ViewChild('iniciativaCardControlRadio') iniciativaCardControlRadio: ContatoIniciativaCardControlRadioComponent;

    // Cliente
    enderecoContatoCliente: PessoaEnderecoContato;
    contatosCliente: PessoaContato[] = [];
    editMode: boolean;
    pessoaContatoIdTable: string;
    @ViewChild('pessoaContato') pessoaContato: PessoaContatoComponent;
    @ViewChild('typeaeadCliente') typeaeadCliente: TypeaheadClienteComponent;

    // Lead
    @ViewChild('leadTypeaead')leadTypeaead: LeadTypeaheadComponent;

    // Retorno
    @ViewChild('retornoForm') retornoForm: AtividadeRetornoFormComponent;

    @Output() afterInsert = new EventEmitter<Atividade>();
    @Output() afterEdit = new EventEmitter<Atividade>();
    @Output() afterCancel = new EventEmitter<Atividade>();
    @Output() afterSave = new EventEmitter<AtividadeAfterSave>();

    @ViewChild('form') form: NgForm;
    @ViewChild('diaPrazo') diaPrazo: DatepickerComponent;
    @ViewChild('atividadeChecklistItem') atividadeChecklistItem: AtividadeChecklistItemComponent;
    tipos = atividadesTiposLancamentoManual;

    /** Configs */
    // Edição
    @Input() canEditTipo = true;
    @Input() canEditReferencia = true;
    @Input() canEditCliente = true;
    @Input() canEditLead = true;
    @Input() canEditUsuarioDestino = true;
    @Input() canEditDataPrazo = true;
    // Outras
    @Input() autoSetUsuarioDestino = true; // Seta automáticamente o usuário logado quando não tiver informado o usuário de destino
    @Input() dataInicialPrazoPadrao: Date = null;
    @Input() dataFinalPrazoPadrao: Date = null;
    @Input() origem: number = origemAtividade.id;
    @Input() referencia: number = referenciaCliente.id;

    @Input() idFunilVenda: number;

    constructor(private el: ElementRef,
                private viewContainerRef: ViewContainerRef,
                private resolver: ComponentFactoryResolver ,
                private authService: AuthService,
                private configService: ConfigService,
                private messageService: MessageService,
                private formsUtilsService: FormsUtilsService,
                private atividadeCrudHttpService: AtividadeCrudHttpService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private pessoaEnderecoContatoHttpService: PessoaEnderecoContatoHttpService,
                private pessoaContatoHttpService: PessoaContatoHttpService,
                private leadSearchHttpService: LeadSearchHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isAdministrador = this.authService.isAdministrador();
        this.isGerente = this.authService.isGerente();
        this.isAtendente = this.authService.isAtendente();

        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.pessoaContatoIdTable = `tablePessoaContatosAtividadeFormModal_${this.entity?.id ?? 0}`;
                this.setConfig();
                this.setFocusInput();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    private setConfig() {
        this.config = {
            isOrigemRetorno: isOrigemRetorno(this.entity?.origem),
            isConcluida: this.entity?.concluida,
            isAtrasada: this.entity?.atrasada && !this.entity?.concluida,
            isPendente: !this.entity?.concluida && !this.entity?.atrasada,
            canEditPrazo: this.canEditDataPrazo && (!this.editMode || (this.entity.idUsuarioOrigem === this.authService.getIdUsuario())) // Somente permitimos atualizar o prazo se estiver inserindo uma nova atividade ou se for o usuário que criou a atividade
        };
    }

    /** Verifica se a referência da atividade é cliente */
    isReferenciaCliente(): boolean {
        if (!this.entity) {
            return false;
        }
        return isReferenciaCliente(this.entity.referencia);
    }

    /** Verifica se a referência da atividade é lead */
    isReferenciaLead(): boolean {
        if (!this.entity) {
            return false;
        }
        return isReferenciaLead(this.entity.referencia);
    }

    /** Ao alterar a referência */
    onChangeReferencia() {
        this.setFocusInput();
    }

    /** Verifica se pode alterar o tipo da atividade */
    canEditTipoFn(): boolean {
        if (!this.entity) {
            return false;
        }

        // Se for uma atividade de lançamento automático nunca pode alterar o tipo
        if (isLancamentoAutomatico(this.entity.lancamento)) {
            return false;
        }

        return this.canEditTipo;
    }

    /** Verifica se pode alterar o cliente da atividade */
    canEditClienteFn(): boolean {
        if (!this.entity) {
            return false;
        }

        // Se for uma atividade de lançamento automático nunca pode alterar o cliente
        if (isLancamentoAutomatico(this.entity.lancamento)) {
            return false;
        }

        return this.canEditCliente;
    }

    /** Verifica se pode alterar o lead da atividade */
    canEditLeadFn(): boolean {
        if (!this.entity) {
            return false;
        }

        // Se for uma atividade de lançamento automático nunca pode alterar o lead
        if (isLancamentoAutomatico(this.entity.lancamento)) {
            return false;
        }

        return this.canEditLead;
    }

    /** Verifica se deve exibir o título da atividade */
    isShowTitulo() {
        if (!this.entity) {
            return false;
        }

        // Somente se não forem os tipos Entrar em contato e Visitar
        return !this.isTipoEntrarEmContato() && !this.isTipoVisitar();
    }

    /** Verifica se pode editar o título da atividade */
    canEditTitulo(): boolean {
        if (!this.entity) {
            return false;
        }

        // Somente pode editar o título se for uma tarefa
        return this.isTipoTarefa();
    }

    /** Cria o nome do cliente para exibir no template */
    createNomeCliente(): string {
        const codigoIntegracaoErp = this.entity?.cliente?.pessoa?.codigoIntegracaoErp ?? '';
        const nome = createNomeCliente(this.configEmpresa.identificacaoCliente, this.entity?.cliente?.pessoa?.nome, this.entity?.cliente?.pessoa?.nomeFantasia);
        return `${codigoIntegracaoErp ? codigoIntegracaoErp + ' - ' : ''}${nome}`;
    }

    /** Seta o foco no input conforme o tipo da atividade */
    private setFocusInput() {
        if (this.isTipoEntrarEmContato()) { // Contato
            this.iniciativaCardControlRadio?.setFocus();
        } else if (this.isTipoVisitar()) { // Visitar
            setTimeout(() => {
                if (this.isReferenciaCliente() && this.canEditCliente) { // Cliente
                    this.typeaeadCliente.setFocus();
                } else if (this.isReferenciaLead() && this.canEditLead) { // Lead
                    this.leadTypeaead.setFocus();
                }
            }, 0);
        } else {
            setTimeout(() => {
                if (this.entity) {
                    jQuery(this.el.nativeElement).find(`#titulo_${this.entity.id ? this.entity.id : 0}`).trigger('focus');
                }
            }, 200);
        }
    }

    private open() {
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    private clear() {
        this.form.resetForm();
        this.entity = null;
        this.enderecoContatoCliente = null;
        this.contatosCliente = [];
    }

    insert(idCliente: number = null, idLead: number = null, idNegocio: number = null, idUsuarioDestino = null) {
        // this.clear();

        this.editMode = false;
        this.entity = new Atividade();
        this.entity.idEmpresa = this.authService.getIdEmpresa();
        this.entity.tipo = tipoEntrarEmContato.id;
        // this.createTitulo();
        this.entity.origem = this.origem;
        this.entity.referencia = this.referencia;
        // this.entity.usuarioDestino = this.authService.getUsuario();
        // this.onTypeaheadChangeUsuarioDestino(this.entity.usuarioDestino);

        this.setDefaultValues(idCliente, idLead, idNegocio, idUsuarioDestino);
        this.open();
    }

    /** Seta os valores padrões da atividade conforme os Inputs e paramêtros informados */
    private async setDefaultValues(idCliente: number = null, idLead: number = null, idNegocio: number = null, idUsuarioDestino = null) {
        try {
            // Cliente
            if (idCliente) {
                this.loadCliente(idCliente)
                    .then((cliente: Cliente) => {
                        if (cliente) {
                            this.entity.idCliente = cliente.id;
                            this.entity.cliente = cliente;

                            if (cliente.pessoa) {
                                this.enderecoContatoCliente = new PessoaEnderecoContato(cliente.pessoa.enderecoPrincipal, cliente.pessoa.contatoPrincipal);
                                this.searchContatosCliente(cliente.pessoa.id);
                            } else {
                                this.enderecoContatoCliente = null;
                                this.contatosCliente = [];
                            }
                        } else {
                            this.entity.idCliente = null;
                            this.entity.cliente = null;
                        }
                    }).
                    catch((error: ApiError) => {

                    });
            }

            // Lead
            if (idLead) {
                const lead = await this.loadLead(idLead);
                if (lead) {
                    this.entity.idLead = lead.id;
                    this.entity.lead = lead;
                } else {
                    this.entity.idLead = null;
                    this.entity.lead = null;
                }
            }

            // Negócio
            if (idNegocio) {
                this.entity.idNegocio = idNegocio;
            }

            // Usuário Destino => Usuário informado ou o usuário que está criando a atividade
            this.entity.idUsuarioDestino = idUsuarioDestino ? idUsuarioDestino : this.authService.getIdUsuario();

            setTimeout(() => {
                // Data Inicial Padrão
                if (this.dataInicialPrazoPadrao) {
                    this.diaPrazo.setStartDate(this.dataInicialPrazoPadrao);
                }
                // Data Final Padrão
                if (this.dataFinalPrazoPadrao) {
                    this.diaPrazo.setEndDate(this.dataFinalPrazoPadrao);
                }
            }, 200);

            // Funil de Vendas
            if (this.idFunilVenda) {
                this.entity.idFunilVendaOld = this.idFunilVenda;
            }
        } catch (error) {

        }
    }

    edit(id: number) {
        // this.clear();

        this.editMode = true;
        this.load(id);
    }

    private load(id: number) {
        this.atividadeCrudHttpService.load(id)
            .subscribe(
                entity => {
                    this.entity = entity;
                    if (entity.cliente && entity.cliente.idPessoa) {
                        this.findEnderecoContatoCliente(entity.cliente.idPessoa);
                        this.searchContatosCliente(entity.cliente.idPessoa);
                    }

                    this.open();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a atividade', error);
                    this.close();
                }
            );
    }

    /** Carrega o cliente */
    private loadCliente(idCliente: number): Promise<Cliente | ApiError> {
        return new Promise<Cliente | ApiError>((resolve, reject) => {
            this.clienteCrudHttpService.load(idCliente)
                .subscribe(
                    cliente => resolve(cliente),
                    ((error: ApiError) => reject(error))
                );
        });
    }

    /** Carrega o endereço e contato do cliente da atividade */
    private findEnderecoContatoCliente(idPessoa: number) {
        this.pessoaEnderecoContatoHttpService.findEnderecoEContato(idPessoa, enderecoTipoPrincipal, contatoTipoPrincipal)
            .pipe(
                take(1)
            )
            .subscribe(
                response => this.enderecoContatoCliente = response,
                (error: ApiError) => this.messageService.error(`${error.message}. Tente selecionar o cliente novamente.`, 'Erro ao carregar o endereço e contato do cliente da atividade', error)
            );
    }

    /** Pesquisa os contatos do cliente */
    private searchContatosCliente(idPessoa: number) {
        this.pessoaContatoHttpService.searchContatos(idPessoa)
            .pipe(
                take(1)
            )
            .subscribe(
                response => this.contatosCliente = response,
                (error: ApiError) => this.messageService.error(`${error.message}. Tente selecionar o cliente novamente.`, 'Erro ao carregar os contatos do cliente da atividade', error)
            );
    }

    /** Carrega o lead da atividade */
    private loadLead(idLead: number): Promise<LeadSearch> {
        return new Promise<LeadSearch>((resolve, reject) => this.leadSearchHttpService.searchOne(idLead)
                        .pipe(
                            take(1)
                        )
                        .subscribe(
                            lead => resolve(lead),
                            (error: ApiError) => reject(error)
                        ));
    }

    close() {
        this.elModal.modal('hide');
    }

    cancel() {
        this.afterCancel.emit();
        this.close();
    }

    private beforeSave() {
        this.setUsuarioDestino();
        this.setDiaNaHoraPrazo();

        // Checklist Itens
        this.atividadeChecklistItem?.beforeSave();
    }

    private isValid(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Se possuir cliente e estiver inserindo ou editando um de seus contatos
        if (this.entity.cliente && this.pessoaContato?.isFormOpen) {
            this.messageService.info('Salve ou cancele o contato do cliente que está sendo inserido ou editado', 'Informação');
            this.pessoaContato.setFocusForm();
            return false;
        }

        // Retorno
        if (this.retornoForm && !this.retornoForm.isValid()) {
            return false;
        }

        if (!this.form.valid) {
            this.formsUtilsService.showMsgFormInvalid();
            return false;
        }

        return true;
    }


     /** Sava a atividade */
    save() {

        if (this.isValid()) {
            this.beforeSave();

            const btnSave = new ButtonLoader(`#btnSaveAtividade_${this.entity.id}`);
            btnSave.loading('Salvando');

            if (this.editMode) { // PUT
                this.atividadeCrudHttpService.update(this.entity)
                    .subscribe(
                        entityResponse => {
                            this.messageService.success('', 'Atividade salva com sucesso');
                            btnSave.reset();
                            this.afterEdit.emit(entityResponse);
                            this.afterSave.emit({
                                isNew: false,
                                entity: entityResponse
                            });
                            this.close();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.cause, 'Erro ao salvar', error);
                            btnSave.reset();
                        }
                    );
            } else { // POST
                this.atividadeCrudHttpService.insert(this.entity)
                    .subscribe(
                        entityResponse => {
                            this.messageService.success('', 'Atividade adicionada com sucesso');
                            btnSave.reset();
                            this.afterInsert.emit(entityResponse);
                            this.afterSave.emit({
                                isNew: true,
                                entity: entityResponse
                            });
                            this.close();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.cause, 'Erro ao salvar', error);
                            btnSave.reset();
                        }
                    );
            }
        }
    }

    /** Cria o título da atividade */
    // private createTitulo() {
    //     if (!this.entity) {
    //         return;
    //     }

    //     if (this.isTipoEntrarEmContato()) {
    //         this.entity.titulo = 'Entrar em Contato';
    //         if (this.entity.cliente && this.entity.cliente.pessoa) {
    //             this.entity.titulo += ' com ' + this.entity.cliente.pessoa.nomeFantasia;
    //         }
    //     } else if (this.isTipoVisitar()) {
    //         this.entity. titulo = 'Visitar';
    //         if (this.entity.cliente && this.entity.cliente.pessoa) {
    //             this.entity.titulo += ' ' + this.entity.cliente.pessoa.nomeFantasia;
    //         }
    //     }
    // }

    /** Ao alterar o tipo da atividade */
    onChangeTipo(tipo: number) {
        if (tipo) {
            this.entity.tipo = tipo;

            // Se for tarefa, limpamos o título
            if (this.isTipoTarefa()) {
                this.entity.titulo = null;
            }
        } else {
            this.entity.tipo = null;
        }

        // this.createTitulo();
        this.setFocusInput();
    }

    /** Verifica se a atividade é do tipo Entrar em Contato */
    isTipoEntrarEmContato() {
        return isTipoEntrarEmContato(this.entity.tipo);
    }

    /** Verifica se a atividade é do tipo Visitar */
    isTipoVisitar() {
        return isTipoVisitar(this.entity.tipo);
    }


    /** Verifica se a atividade é do tipo tarefa */
    isTipoTarefa() {
        return isTipoTarefa(this.entity.tipo);
    }

    /** Verifica se o tipo da atividade é cliente revisão */
    isTipoClienteRevisao() {
        return isTipoClienteRevisao(this.entity.tipo);
    }

    /** Verifica se a atividade é do tipo cliente título vencido */
    isTipoClienteTituloVencido() {
        return isTipoClienteTituloVencido(this.entity.tipo);
    }

    /** Ao alterar o usuário de destino (responsável) */
    onTypeaheadChangeUsuarioDestino(usuarioDestino: Usuario) {
        if (usuarioDestino) {
            this.entity.idUsuarioDestino = usuarioDestino.id;
        } else {
            this.entity.idUsuarioDestino = null;
        }
    }

    private clearCliente() {
        this.entity.idCliente = null;
        this.entity.cliente = null;
        this.enderecoContatoCliente = null;
        this.contatosCliente = [];
    }

    onClienteSelectedTypeahead(cliente: Cliente) {
        if (cliente) {
            this.entity.idCliente = cliente.id;
            this.findEnderecoContatoCliente(cliente.idPessoa);
            this.searchContatosCliente(cliente.idPessoa);
        } else {
            this.clearCliente();
        }
    }

    onClearClienteTypeahead() {
        this.clearCliente();
    }

    private clearLead() {
        this.entity.idLead = null;
        this.entity.lead = null;
    }

    onLeadSelectedTypeahead(lead: LeadSearch) {
        if (lead) {
            this.entity.idLead = lead.id;
        } else {
            this.clearLead();
        }
    }

    onClearLeadTypeahead() {
        this.clearLead();
    }

    /** Alterna a opção de Sinalizado */
    toggleSinalizado() {
        this.entity.sinalizado = !this.entity.sinalizado;
    }

    /** Alterna a opção de Importante */
    toggleImportante() {
        this.entity.importante = !this.entity.importante;
    }

    /** Verifica se é para exibir o usuário de origem da atividade */
    isShowUsuarioOrigem(): boolean {
        return this.entity.idUsuarioOrigem != null && this.entity.idUsuarioOrigem !== undefined;
    }

    /** Verifica se pode atribuir o usuário de destino da atividade */
    canAtribuirUsuarioDestino(): boolean {
        // Se não puder editar o usuário de destino
        if (!this.canEditUsuarioDestino) {
            return false;
        }
        // Por enquanto somente o administrado pode atribuir para qualquer usuário ou os gerentes e atendentes para os usuários de seus representantes
        return this.isAdministrador || this.isGerente || this.isAtendente;
    }

    /** Verifica se é para exibir o usuário de destino da atividade */
    isShowUsuarioDestino(): boolean {
        return this.canAtribuirUsuarioDestino() || this.editMode;
    }

    /** Seta automáticamente o usuário logando no usuário de destino quando não estiver informado o usuário de destino da atividade */
    private setUsuarioDestino() {
        // Se não for para setar automáticamente o usuário de destino com o usuário logado quando não estiver informado o usuário de destino da atividade
        if (!this.autoSetUsuarioDestino) {
            return false;
        }

        // Se não tiver sido informado o usuário de destino da atividade, então setamos o próprio usuário
        if (!this.entity.idUsuarioDestino || !this.canAtribuirUsuarioDestino()) {
            this.entity.idUsuarioDestino = this.authService.getUsuario().id;
        }
    }

    /** Seta o dia do prazo na hora para ficar o dia correto na hora */
    private setDiaNaHoraPrazo() {
        if (!this.config?.canEditPrazo || !this.entity.horaPrazo) {
            return;
        }

        const dia = this.entity.diaPrazo ? new Date(this.entity.diaPrazo) : new Date();
        const horaPrazo = this.entity.horaPrazo ? new Date(this.entity.horaPrazo) : new Date();
        this.entity.horaPrazo = new Date(dia.getFullYear(),
                                            dia.getMonth(),
                                            dia.getDate(),
                                            horaPrazo.getHours(),
                                            horaPrazo.getMinutes(),
                                            horaPrazo.getSeconds(),
                                            horaPrazo.getMilliseconds()
                                        );
    }

    /** Abre a atividade de retorno */
    openAtividadeRetorno(atividadeRetorno: AtividadeRef) {
        if (!atividadeRetorno) {
            return;
        }
        // Criando modal
        const factory = this.resolver.resolveComponentFactory(AtividadeFormModalComponent);
        const modal = this.viewContainerRef.createComponent(factory);
        // Editiando atividade de retorno
        modal.instance.edit(atividadeRetorno.id);
        // Realizando subscribe no after save para mapear as alterações feitas
        modal.instance.afterSave.subscribe(
            (atividadeAfterSave: AtividadeAfterSave) => this.entity.atividadeRetorno = atividadeAfterSave ? mapToRef(atividadeAfterSave.entity) : null
        );
    }
}
